/**
 * Once we can verify that the BE is injecting the environment config into
 * EVERY page, this can be removed. At that point our build scripts can stop
 * injecting these and we can have 1 build that runs on any environment.
 */
const defaultEnvironment = {
  /* eslint-disable no-restricted-syntax */
  cdnURL: process.env.CDN_URL as string,
  hsHost: process.env.HS_DOMAIN as string,
  hfHost: process.env.HF_DOMAIN as string,
  hfName: process.env.HF_NAME as string,
  hsName: process.env.HS_NAME as string,
  hwName: process.env.HW_NAME as string,
  sentryDSN: process.env.HS_SENTRY_DSN as string,
  sentryEnvironment: process.env.SENTRY_ENVIRONMENT as string,
  /* eslint-enable no-restricted-syntax */
};

const runtimeEl = document.getElementById('hs-env');
const runtimeEnvironment: typeof defaultEnvironment = runtimeEl === null ? defaultEnvironment : {
  ...defaultEnvironment,
  ...JSON.parse(runtimeEl.innerHTML),
};

export const {
  cdnURL,
  hsHost,
  hfHost,
  hfName,
  hsName,
  hwName,
  sentryDSN,
  sentryEnvironment,
} = runtimeEnvironment;
